export const PER_PAGE = 500;
export const FETCH_SALES = 'FETCH_SALES';

